import { useEffect } from 'react';
var useEffectOnce = function (effect) {
    useEffect(effect, []);
};
export default useEffectOnce;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useEffectOnce.js
// module id = TDPR
// module chunks = 0